import React from "react";

const SvgBBiconsSekce = props => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200" {...props}>
        <g id="Obecné_ikony" data-name="Obecné ikony">
            <g id="Layer_2" data-name="Layer 2">
                <path d="M87,37.37a1.09,1.09,0,0,1,1.09,1.09V87A1.09,1.09,0,0,1,87,88.1H38.46A1.09,1.09,0,0,1,37.37,87V38.46a1.09,1.09,0,0,1,1.09-1.09H87m0-7H38.46a8.09,8.09,0,0,0-8.09,8.09V87a8.09,8.09,0,0,0,8.09,8.09H87A8.09,8.09,0,0,0,95.1,87V38.46A8.09,8.09,0,0,0,87,30.37Z"/>
                <path d="M113,30.37h48.55a8.09,8.09,0,0,1,8.09,8.09V87a8.09,8.09,0,0,1-8.09,8.09H113A8.09,8.09,0,0,1,104.9,87V38.46A8.09,8.09,0,0,1,113,30.37Z"/>
                <path d="M38.46,104.9H87A8.09,8.09,0,0,1,95.1,113v48.55A8.09,8.09,0,0,1,87,169.63H38.46a8.09,8.09,0,0,1-8.09-8.09V113A8.09,8.09,0,0,1,38.46,104.9Z"/>
                <path d="M113,104.9h48.55a8.09,8.09,0,0,1,8.09,8.09v48.55a8.09,8.09,0,0,1-8.09,8.09H113a8.09,8.09,0,0,1-8.09-8.09V113A8.09,8.09,0,0,1,113,104.9Z"/>
            </g>
        </g>
    </svg>
);

export default SvgBBiconsSekce;

